import { Injectable, inject } from '@angular/core';
import { getPendingService } from 'src/app/services/pendingHttpServices.service';

import { ConfirmationDialogService } from 'src/app/services/confirmation-dialog.service';
import { Observable, Observer } from 'rxjs';
import { UtilService } from '../services/util.service';

export interface CanDeactivateComponent {
  canDeactivate(): boolean;
}
@Injectable({ providedIn: 'root' })
export class CanDeactivateGuard {
  private getPendingService = inject(getPendingService);
  private confirmationDialogService = inject(ConfirmationDialogService);
  private utilService = inject(UtilService);

  canDeactivate() {
    if (this.getPendingService.isPending.getValue()) {
      return Observable.create((observer: Observer<boolean>) => {
        this.confirmationDialogService.confirm({
          message:
            'Save is inprogress.You may miss some change if you leave the page now. Are you sure you want to leave this page?',
          accept: () => {
            observer.next(true);
            observer.complete();
          },
          reject: () => {
            observer.next(false);
            observer.complete();
          }
        });
      });
    }
    if (this.utilService.value) {
      return Observable.create((observer: Observer<boolean>) => {
        this.confirmationDialogService.confirm({
          message:
            'Are you sure that you want to navigate to other page without filling mandatory fields in Environment properties section?',
          header: 'Confirmation',
          acceptIcon: 'pi pi-check',
          rejectIcon: 'pi pi-times',
          accept: () => {
            observer.next(true);
            observer.complete();
          },
          reject: () => {
            observer.next(false);
            observer.complete();
          }
        });
      });
    }

    return true;
  }
}


